import React from "react";
import { Form, Input, Row, Col, Card, Typography, Button } from "antd";
import { PlusOutlined, MinusCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const { Title } = Typography;

interface EmergencyTabProps {
  form: any;
}

export const EmergencyTab: React.FC<EmergencyTabProps> = ({ form }) => {
  return (
    <div>
      <Title level={4}>
        <ExclamationCircleOutlined style={{ marginRight: '8px' }} />
        Notfallnummern
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="Allgemeine Notfälle" size="small">
            <Form.List name={['content', 'emergency', 'general']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key} 
                      size="small" 
                      style={{ marginBottom: '8px' }}
                      extra={
                        <Button 
                          type="text" 
                          danger 
                          size="small"
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      }
                    >
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'number']}
                            label="Nummer"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Nummer ein' }]}
                          >
                            <Input placeholder="z.B. 112" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            label="Beschreibung"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Beschreibung ein' }]}
                          >
                            <Input placeholder="z.B. Feuerwehr & Rettungsdienst" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      size="small"
                      icon={<PlusOutlined />}
                    >
                      Notfallnummer hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Unser Haus" size="small">
            <Form.List name={['content', 'emergency', 'house']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key} 
                      size="small" 
                      style={{ marginBottom: '8px' }}
                      extra={
                        <Button 
                          type="text" 
                          danger 
                          size="small"
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      }
                    >
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'number']}
                            label="Nummer"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Nummer ein' }]}
                          >
                            <Input placeholder="+49 123 456789" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            label="Beschreibung"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Beschreibung ein' }]}
                          >
                            <Input placeholder="z.B. Rezeption (24h)" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      size="small"
                      icon={<PlusOutlined />}
                    >
                      Hausnummer hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={12}>
          <Card title="Weitere wichtige Nummern" size="small">
            <Form.List name={['content', 'emergency', 'additional']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key} 
                      size="small" 
                      style={{ marginBottom: '8px' }}
                      extra={
                        <Button 
                          type="text" 
                          danger 
                          size="small"
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      }
                    >
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'number']}
                            label="Nummer"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Nummer ein' }]}
                          >
                            <Input placeholder="z.B. 030 19240" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            label="Beschreibung"
                            rules={[{ required: true, message: 'Bitte geben Sie eine Beschreibung ein' }]}
                          >
                            <Input placeholder="z.B. Giftnotruf" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      size="small"
                      icon={<PlusOutlined />}
                    >
                      Nummer hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Adresse für Notfälle" size="small">
            <Form.Item
              name={['content', 'emergency', 'address']}
              label="Vollständige Adresse"
              rules={[{ required: true, message: 'Bitte geben Sie die Adresse ein' }]}
            >
              <Input.TextArea 
                rows={3} 
                placeholder="Musterstraße 123, 12345 Musterstadt, Deutschland"
              />
            </Form.Item>

            <Form.Item
              name={['content', 'emergency', 'notes']}
              label="Besondere Hinweise"
            >
              <Input.TextArea 
                rows={2} 
                placeholder="Besondere Hinweise für Notfälle..."
              />
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <Card title="Vordefinierte Notfallnummern" size="small">
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <Button 
                size="small"
                onClick={() => {
                  const currentGeneral = form.getFieldValue(['content', 'emergency', 'general']) || [];
                  form.setFieldValue(['content', 'emergency', 'general'], [
                    ...currentGeneral,
                    { number: '112', description: 'Feuerwehr & Rettungsdienst' }
                  ]);
                }}
              >
                112 - Feuerwehr & Rettungsdienst
              </Button>
              <Button 
                size="small"
                onClick={() => {
                  const currentGeneral = form.getFieldValue(['content', 'emergency', 'general']) || [];
                  form.setFieldValue(['content', 'emergency', 'general'], [
                    ...currentGeneral,
                    { number: '110', description: 'Polizei' }
                  ]);
                }}
              >
                110 - Polizei
              </Button>
              <Button 
                size="small"
                onClick={() => {
                  const currentGeneral = form.getFieldValue(['content', 'emergency', 'general']) || [];
                  form.setFieldValue(['content', 'emergency', 'general'], [
                    ...currentGeneral,
                    { number: '116 117', description: 'Ärztlicher Bereitschaftsdienst' }
                  ]);
                }}
              >
                116 117 - Ärztlicher Bereitschaftsdienst
              </Button>
              <Button 
                size="small"
                onClick={() => {
                  const currentAdditional = form.getFieldValue(['content', 'emergency', 'additional']) || [];
                  form.setFieldValue(['content', 'emergency', 'additional'], [
                    ...currentAdditional,
                    { number: '030 19240', description: 'Giftnotruf' }
                  ]);
                }}
              >
                030 19240 - Giftnotruf
              </Button>
              <Button 
                size="small"
                onClick={() => {
                  const currentAdditional = form.getFieldValue(['content', 'emergency', 'additional']) || [];
                  form.setFieldValue(['content', 'emergency', 'additional'], [
                    ...currentAdditional,
                    { number: '116 116', description: 'Sperrnotruf' }
                  ]);
                }}
              >
                116 116 - Sperrnotruf
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 